<div class="crud-item-page">
  <form [formGroup]="form">
    <div class="crud-item-section">

      <span>
        <mat-form-field matTooltip="Name" [matTooltipDisabled]="disabledTooltip(this.name)">
          <mat-label i18n="@@type.Role.name">Name</mat-label>
          <input matInput formControlName="name" id="name" (ngModelChange)="nameChanging($event)"
            [(ngModel)]="item.name" (ngModelChange)="nameChanged($event)" #id placeholder="Name" uppercase>
        </mat-form-field>
      </span>

      <span>
        <mat-form-field matTooltip="Description" [matTooltipDisabled]="disabledTooltip(this.description)">
          <mat-label i18n="@@type.Role.description">Description</mat-label>
          <input matInput formControlName="description" id="description" (ngModelChange)="descriptionChanging($event)"
            [(ngModel)]="item.description" (ngModelChange)="descriptionChanged($event)" #description maxlength="255"
            placeholder="Description">
        </mat-form-field>
      </span>

      <span>
        <mat-slide-toggle floatLabel="always" appearance="none" color="primary" formControlName="systemProvided"
          id="systemProvided" (ngModelChange)="systemProvidedChanging($event)" [(ngModel)]="item.systemProvided"
          (ngModelChange)="systemProvidedChanged($event)" #enabled i18n="@@type.Role.systemProvided">
          System Provided </mat-slide-toggle>
      </span>

    </div>
    <mat-divider></mat-divider>

    <div class="crud-item-section">
      <div class="chip-field">
        <mat-chip-list #ownPrivilegesChips>
          <mat-chip *ngFor="let privilege of item.ownPrivileges" [selectable]="!readOnly" [removable]="!readOnly"
            (removed)="removeOwnPrivilege(privilege)" color="primary" [matTooltip]="privilege.description">
            {{privilege.name}}
            <mat-icon matChipRemove *ngIf="!readOnly">cancel</mat-icon>
          </mat-chip>
        </mat-chip-list>
        <mat-form-field matTooltip="Select a Privilege from the list"
          [matTooltipDisabled]="disabledTooltip(this.ownPrivileges)" class="crud-item-input-wide">
          <mat-label i18n="@@type.Role.ownPrivileges">Privileges</mat-label>
          <input matInput [matAutocomplete]="ownPrivilegesAutocomplete" [matChipInputFor]="ownPrivilegesChips"
            formControlName="ownPrivileges" id="ownPrivileges" #ownPrivileges placeholder="Privileges">
          <mat-autocomplete id="ownPrivilegesAutocomplete" #ownPrivilegesAutocomplete
            [displayWith]="ownPrivilegesDisplay" (optionSelected)="selectedOwnPrivilege($event)">
            <mat-option *ngFor="let ownPrivilege of ownPrivilegesSelectionList | async" [value]="ownPrivilege">
              {{ownPrivilegesDisplay(ownPrivilege)}}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
      </div>

    </div>
    <mat-divider></mat-divider>

    <div class="crud-item-section">
      <div class="chip-field">
        <mat-chip-list #nestedRolesChips>
          <mat-chip *ngFor="let role of item.nestedRoles" [selectable]="!readOnly" [removable]="!readOnly"
            (removed)="removeNestedRole(role)" color="accent" [matTooltip]="role.description">
            {{role.name}}
            <mat-icon matChipRemove *ngIf="!readOnly">cancel</mat-icon>
          </mat-chip>
        </mat-chip-list>
        <mat-form-field matTooltip="Select a Role from the list"
          [matTooltipDisabled]="disabledTooltip(this.nestedRoles)" class="crud-item-input-wide">
          <mat-label i18n="@@type.Role.nestedRoles">Included Roles</mat-label>
          <input matInput [matAutocomplete]="nestedRolesAutocomplete" [matChipInputFor]="nestedRolesChips"
            formControlName="nestedRoles" id="nestedRoles" #nestedRoles placeholder="Included Roles">
          <mat-autocomplete id="nestedRolesAutocomplete" #nestedRolesAutocomplete [displayWith]="nestedRolesDisplay"
            (optionSelected)="selectedNestedRole($event)">
            <mat-option *ngFor="let nestedRole of nestedRolesSelectionList | async" [value]="nestedRole">
              {{nestedRolesDisplay(nestedRole)}}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
      </div>

    </div>
    <mat-divider></mat-divider>

  </form>
</div>